import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  Input,
  Select,
  Space,
  Tag,
  Modal,
  Row,
  Col,
  Statistic,
  Tooltip,
  message,
  Descriptions,
  DatePicker,
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
  EyeOutlined,
  FilterOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

const BalanceLogs: React.FC = () => {
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterSubCategory, setFilterSubCategory] = useState('all');
  const [filterNature, setFilterNature] = useState('all');
  const [agentId, setAgentId] = useState('');
  const [dateRange, setDateRange] = useState<any>(null);

  // 模拟账变记录数据
  const balanceData = [
    {
      id: 1,
      balanceId: 'BAL202510231200001',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'ACT_HBY_202510231200',
      category: '活动',
      subCategory: '红包雨',
      amount: 88.00,
      balanceBefore: 1000.00,
      balanceAfter: 1088.00,
      nature: '收入',
      tradeTime: '2025-10-23 12:00:01',
      description: '红包雨活动奖励',
      remark: '国庆红包雨第3期',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 2,
      balanceId: 'BAL202510231030001',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'ACT_QD_202510230800',
      category: '活动',
      subCategory: '签到奖励',
      amount: 10.00,
      balanceBefore: 1088.00,
      balanceAfter: 1098.00,
      nature: '收入',
      tradeTime: '2025-10-23 10:30:00',
      description: '每日签到奖励',
      remark: '第7天签到奖励',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 3,
      balanceId: 'BAL202510231400000',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'DEP_202510231400',
      category: '入款',
      subCategory: '在线充值',
      amount: 100.00,
      balanceBefore: 1098.00,
      balanceAfter: 1198.00,
      nature: '收入',
      tradeTime: '2025-10-23 14:00:00',
      description: '在线充值',
      remark: '微信支付',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 4,
      balanceId: 'BAL202510231400001',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'ACT_CZZS_202510231400',
      category: '活动',
      subCategory: '充值赠送',
      amount: 30.00,
      balanceBefore: 1198.00,
      balanceAfter: 1228.00,
      nature: '收入',
      tradeTime: '2025-10-23 14:00:00',
      description: '充值赠送活动奖励',
      remark: '充100送30活动',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 5,
      balanceId: 'BAL202510232000002',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'BET_SLT_202510232000',
      category: '游戏',
      subCategory: '投注',
      amount: -50.00,
      balanceBefore: 1228.00,
      balanceAfter: 1178.00,
      nature: '支出',
      tradeTime: '2025-10-23 20:00:00',
      description: '游戏投注',
      remark: '老虎机投注',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 6,
      balanceId: 'BAL202510232010003',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      orderId: 'WIN_202510232010',
      category: '游戏',
      subCategory: '派彩',
      amount: 150.00,
      balanceBefore: 1178.00,
      balanceAfter: 1328.00,
      nature: '收入',
      tradeTime: '2025-10-23 20:10:00',
      description: '游戏派彩',
      remark: '老虎机中奖',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 7,
      balanceId: 'BAL202510231500001',
      userId: 'user_002',
      username: '李四',
      agentId: 'agent_002',
      orderId: 'LIVE_TICKET_202510231500',
      category: '游戏',
      subCategory: '付门票看直播',
      amount: -20.00,
      balanceBefore: 500.00,
      balanceAfter: 480.00,
      nature: '支出',
      tradeTime: '2025-10-23 15:00:00',
      description: '付门票看直播',
      remark: '直播间ID: LIVE_001, 子游戏: 百家乐',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_002',
      topAgentId: 'top_002',
    },
    {
      id: 8,
      balanceId: 'BAL202510231600001',
      userId: 'user_003',
      username: '王五',
      agentId: 'agent_003',
      orderId: 'LIVE_DURATION_202510231600',
      category: '游戏',
      subCategory: '时长付费直播',
      amount: -50.00,
      balanceBefore: 1000.00,
      balanceAfter: 950.00,
      nature: '支出',
      tradeTime: '2025-10-23 16:00:00',
      description: '时长付费直播',
      remark: '直播间ID: LIVE_002, 观看时长: 30分钟, 子游戏: 轮盘',
      operator: null,
      operationReason: null,
      parentAgentId: 'parent_003',
      topAgentId: 'top_003',
    },
  ];


  const handleViewDetail = (record: any) => {
    setSelectedRecord(record);
    setDetailModalVisible(true);
  };

  const handleRefresh = () => {
    setLoading(true);
    message.loading('正在刷新数据...', 1);
    setTimeout(() => {
      setLoading(false);
      message.success('数据刷新成功！');
    }, 1500);
  };

  const handleExport = () => {
    message.loading('正在导出数据...', 1);
    setTimeout(() => {
      message.success('数据导出成功！');
    }, 1500);
  };

  const getCategoryColor = (category: string) => {
    const colors: Record<string, string> = {
      '活动': 'orange',
      '入款': 'green',
      '出款': 'red',
      '游戏': 'blue',
    };
    return colors[category] || 'default';
  };

  const columns = [
    {
      title: '账变ID',
      dataIndex: 'balanceId',
      key: 'balanceId',
      width: 180,
      fixed: 'left' as const,
      render: (text: string) => (
        <Tooltip title="点击复制">
          <span style={{ cursor: 'pointer' }} onClick={() => {
            navigator.clipboard.writeText(text);
            message.success('复制成功');
          }}>
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: '用户信息',
      key: 'userInfo',
      width: 120,
      render: (_: any, record: any) => (
        <div>
          <div style={{ fontWeight: 'bold' }}>{record.username}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.userId}</div>
        </div>
      ),
    },
    {
      title: '关联订单号',
      dataIndex: 'orderId',
      key: 'orderId',
      width: 180,
    },
    {
      title: '交易大类',
      dataIndex: 'category',
      key: 'category',
      width: 80,
      render: (category: string) => (
        <Tag color={getCategoryColor(category)}>{category}</Tag>
      ),
    },
    {
      title: '交易小类',
      dataIndex: 'subCategory',
      key: 'subCategory',
      width: 100,
    },
    {
      title: '交易金额',
      dataIndex: 'amount',
      key: 'amount',
      width: 100,
      sorter: (a: any, b: any) => Math.abs(a.amount) - Math.abs(b.amount),
      render: (amount: number) => (
        <span style={{ 
          color: amount > 0 ? '#3f8600' : '#cf1322', 
          fontWeight: 'bold' 
        }}>
          {amount > 0 ? '+' : ''}¥{amount.toFixed(2)}
        </span>
      ),
    },
    {
      title: '账变前余额',
      dataIndex: 'balanceBefore',
      key: 'balanceBefore',
      width: 120,
      render: (amount: number) => `¥${amount.toFixed(2)}`,
    },
    {
      title: '账变后余额',
      dataIndex: 'balanceAfter',
      key: 'balanceAfter',
      width: 120,
      render: (amount: number) => `¥${amount.toFixed(2)}`,
    },
    {
      title: '交易性质',
      dataIndex: 'nature',
      key: 'nature',
      width: 80,
      render: (nature: string) => (
        <Tag color={nature === '收入' ? 'success' : 'error'}>{nature}</Tag>
      ),
    },
    {
      title: '交易时间',
      dataIndex: 'tradeTime',
      key: 'tradeTime',
      width: 160,
      sorter: (a: any, b: any) => new Date(a.tradeTime).getTime() - new Date(b.tradeTime).getTime(),
    },
    {
      title: '交易描述',
      dataIndex: 'description',
      key: 'description',
      width: 150,
      ellipsis: true,
    },
    {
      title: '业务备注',
      dataIndex: 'remark',
      key: 'remark',
      width: 150,
      ellipsis: true,
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      fixed: 'right' as const,
      render: (_: any, record: any) => (
        <Tooltip title="查看详情">
          <Button type="link" icon={<EyeOutlined />} onClick={() => handleViewDetail(record)}>
            详情
          </Button>
        </Tooltip>
      ),
    },
  ];

  const filteredData = balanceData.filter(item => {
    const matchesSearch = !searchText || 
      item.balanceId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.userId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.orderId.toLowerCase().includes(searchText.toLowerCase());
    
    const matchesCategory = filterCategory === 'all' || item.category === filterCategory;
    const matchesSubCategory = filterSubCategory === 'all' || item.subCategory === filterSubCategory;
    const matchesNature = filterNature === 'all' || item.nature === filterNature;
    const matchesAgent = !agentId || item.agentId === agentId;
    
    // 日期范围过滤
    const matchesDate = !dateRange || (
      new Date(item.tradeTime) >= dateRange[0].toDate() &&
      new Date(item.tradeTime) <= dateRange[1].toDate()
    );
    
    return matchesSearch && matchesCategory && matchesSubCategory && matchesNature && matchesAgent && matchesDate;
  });

  // 根据过滤后的数据计算统计数据
  const statsData = {
    totalIncome: filteredData.filter(item => item.nature === '收入').reduce((sum, item) => sum + item.amount, 0),
    totalExpense: filteredData.filter(item => item.nature === '支出').reduce((sum, item) => sum + Math.abs(item.amount), 0),
    netChange: filteredData.filter(item => item.nature === '收入').reduce((sum, item) => sum + item.amount, 0) - 
               filteredData.filter(item => item.nature === '支出').reduce((sum, item) => sum + Math.abs(item.amount), 0),
    totalCount: filteredData.length,
  };

  // 根据大类动态加载小类
  const subCategoryOptions = () => {
    switch (filterCategory) {
      case '活动':
        return ['全部小类', '红包雨', '转盘抽奖', '签到奖励', '充值赠送', '邀请好友', 'VIP福利', '任务奖励'];
      case '入款':
        return ['全部小类', '在线充值', '人工入款', '提现退回', '系统补偿', '投诉补偿'];
      case '出款':
        return ['全部小类', '提现', '人工扣款', '违规扣除', '手续费'];
      case '游戏':
        return ['全部小类', '投注', '派彩', '投注取消', '返水', '大奖', '付门票看直播', '时长付费直播'];
      default:
        return [];
    }
  };

  return (
    <div style={{ padding: 24 }}>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="收入总额" prefix="¥" value={statsData.totalIncome.toFixed(2)} valueStyle={{ color: '#3f8600' }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="支出总额" prefix="¥" value={statsData.totalExpense.toFixed(2)} valueStyle={{ color: '#cf1322' }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic 
              title="净变动" 
              prefix="¥" 
              value={statsData.netChange.toFixed(2)} 
              valueStyle={{ color: statsData.netChange >= 0 ? '#3f8600' : '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="交易总笔数" value={statsData.totalCount} />
          </Card>
        </Col>
      </Row>

      <Card
        title="资金日志"
        extra={
          <Space>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={loading}
            >
              刷新
            </Button>
            <Button
              icon={<ExportOutlined />}
              onClick={handleExport}
            >
              导出Excel
            </Button>
          </Space>
        }
      >
        {/* 搜索和筛选 */}
        <div style={{ marginBottom: 16 }}>
          <Space wrap>
            <Input
              placeholder="搜索账变ID、用户ID或订单号"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 300 }}
            />
            <Select
              value={filterCategory}
              onChange={(value) => {
                setFilterCategory(value);
                setFilterSubCategory('all');
              }}
              style={{ width: 100 }}
            >
              <Option value="all">全部大类</Option>
              <Option value="活动">活动</Option>
              <Option value="入款">入款</Option>
              <Option value="出款">出款</Option>
              <Option value="游戏">游戏</Option>
            </Select>
            <Select
              value={filterSubCategory}
              onChange={setFilterSubCategory}
              style={{ width: 120 }}
              disabled={filterCategory === 'all'}
            >
              <Option value="all">全部小类</Option>
              {subCategoryOptions().slice(1).map(opt => (
                <Option key={opt} value={opt}>{opt}</Option>
              ))}
            </Select>
            <Select
              value={filterNature}
              onChange={setFilterNature}
              style={{ width: 100 }}
            >
              <Option value="all">全部性质</Option>
              <Option value="收入">收入</Option>
              <Option value="支出">支出</Option>
            </Select>
            <Input
              placeholder="代理ID"
              value={agentId}
              onChange={(e) => setAgentId(e.target.value)}
              style={{ width: 150 }}
              allowClear
            />
            <RangePicker
              value={dateRange}
              onChange={setDateRange}
              showTime
              style={{ width: 350 }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Space>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          loading={loading}
          pagination={{
            total: filteredData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条记录`,
          }}
          scroll={{ x: 1600 }}
        />
      </Card>

      {/* 详情模态框 */}
      <Modal
        title="账变详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetailModalVisible(false)}>
            关闭
          </Button>,
        ]}
        width={700}
      >
        {selectedRecord && (
          <div>
            <Descriptions column={2} bordered>
              <Descriptions.Item label="账变ID">{selectedRecord.balanceId}</Descriptions.Item>
              <Descriptions.Item label="用户ID">{selectedRecord.userId}</Descriptions.Item>
              <Descriptions.Item label="关联订单号">{selectedRecord.orderId}</Descriptions.Item>
              <Descriptions.Item label="交易大类">
                <Tag color={getCategoryColor(selectedRecord.category)}>{selectedRecord.category}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="交易小类">{selectedRecord.subCategory}</Descriptions.Item>
              <Descriptions.Item label="交易性质">
                <Tag color={selectedRecord.nature === '收入' ? 'success' : 'error'}>
                  {selectedRecord.nature}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="交易金额">
                <span style={{ 
                  color: selectedRecord.amount > 0 ? '#3f8600' : '#cf1322',
                  fontWeight: 'bold'
                }}>
                  {selectedRecord.amount > 0 ? '+' : ''}¥{selectedRecord.amount.toFixed(2)}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="账变前余额">¥{selectedRecord.balanceBefore.toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label="账变后余额">¥{selectedRecord.balanceAfter.toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label="交易时间">{selectedRecord.tradeTime}</Descriptions.Item>
              <Descriptions.Item label="交易描述">{selectedRecord.description}</Descriptions.Item>
              <Descriptions.Item label="业务备注" span={2}>{selectedRecord.remark || '-'}</Descriptions.Item>
              {selectedRecord.operator && (
                <Descriptions.Item label="操作人">{selectedRecord.operator}</Descriptions.Item>
              )}
              {selectedRecord.operationReason && (
                <Descriptions.Item label="操作原因">{selectedRecord.operationReason}</Descriptions.Item>
              )}
            </Descriptions>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default BalanceLogs;
